// WealthContext.js
import React, { createContext, useState } from "react";

export const WealthContext = createContext();

export const WealthProvider = ({ children }) => {
  const [revenueMade, setRevenueMade] = useState(0);
  const [revenueLost, setRevenueLost] = useState(0);

  return (
    <WealthContext.Provider
      value={{ revenueMade, setRevenueMade, revenueLost, setRevenueLost }}
    >
      {children}
    </WealthContext.Provider>
  );
};
